<template>
  <div class="mx-0 w-100 align-self-start">
    <LoadingDialog :loading="fetchInProgress" />
    <ReflectionFreeRedaction
      v-if="(reflection && !fetchInProgress)"
      :reflection="reflection"
      :reflection-id="reflection.id"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { types } from '@/store/rootTypes';
import ReflectionFreeRedaction from './report/ReflectionFreeRedaction';

export default {
  name: 'ReflectionDetails',
  components: { ReflectionFreeRedaction },
  data() {
    return {
      currentTab: '',
      tabs: ['documents', 'reflections', 'Rédaction'],
    };
  },
  computed: {
    ...mapGetters({
      reflection: types.reflections.getters.reflection,
      fetchInProgress: types.reflections.getters.fetchInProgress,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { hash } = to;
      const nextTab = vm.tabs.indexOf((hash || '').replace('#', ''));
      vm.currentTab = nextTab > -1 ? nextTab : 0;
    });
  },
  beforeRouteLeave(to, from, next) {
    document.title = 'NOOS';
    next();
  },
  watch: {
    reflection(reflection) {
      if (!reflection) return;

      document.title = reflection.title;
    },
  },
};
</script>

<style scoped>
.header {
 min-height: 100px;
}
p {
  max-width: 100%;
  max-height: 50px;
}
</style>
